"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordInterestService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordInterestService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordInterestService.instance) {
      return CordInterestService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordInterestService.instance = this;
  }
  getInterestRates(queryObj) {
    return this.post('moneyview/interestRates', queryObj);
  }
  getInterestRatesFutureDocuments(documentStatus = 'A') {
    return this.get(`moneyview/interestRatesFuture?documentStatus=${documentStatus}`);
  }
  getInterestRatesForRespiteDates(respiteDates) {
    let respiteDatesForApi = '';
    respiteDates.forEach(date => {
      respiteDatesForApi += respiteDatesForApi.length > 1 ? '&' : '';
      respiteDatesForApi += 'respiteDates=' + date;
    });
    return this.get(`moneyview/interestRatesFuture?${respiteDatesForApi}`);
  }
  getInterestRatesDocumentById(documentId, documentStatus = 'A') {
    return this.get(`moneyview/interestRatesDocument/${documentId}?documentStatus=${documentStatus}`);
  }
  getMoneyviewCredentials() {
    return this.get('moneyview/hypoBieb');
  }
  compareInterestRates(compareInterestRateRequest) {
    return this.post('moneyview/interestRatesComparison', compareInterestRateRequest);
  }
}
exports.CordInterestService = CordInterestService;
CordInterestService.instance = null;
